import { get, post, put, del } from './request';

class Stats {
  static list({ body }) {
    return post('/stats/getDashboardStats', body).then((res) => res.data);
  }
}

export default Stats;
